export default __webpack_public_path__ + "static/media/image-main-3-m.1a76ad01.webp";